import styles from './ValidationMessage.module.css';

export default ({ message }: IValidationMessageProps) => {

    return (
        <div className={styles.container}>
            {messages[message] || message}
        </div>
    );
}

interface IValidationMessageProps {
    message: string;
}

const messages: Record<string, string> = {
    ["Expected string, received null"]: "Required",
    ["Expected number, received null"]: "Required",
    ["Expected date, received null"]: "Required",
    ["Number must be greater than or equal to 0"]: "Must be 0 or positive",
    ["Number must be greater than 0"]: "Must be positive",
    ["Expected integer, received float"]: "Must be integer",
    ["String cannot contain negative numbers"]: "Must be 0 or positive",
};